
export default {
    accAdd(arg1, arg2) { //加法
        console.log('调用加法')
        //加法精度
        var r1, r2, m;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    },
    NumMul(arg1, arg2) {  //乘法
        console.log('调用乘法')
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) { }
        try {
            m += s2.split(".")[1].length;
        } catch (e) { }

        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    NumDiv(num1, num2) {  //除法
        var t1, t2, r1, r2;
        try { t1 = num1.toString().split('.')[1].length; } catch (e) {
            t1 = 0;

        }
        try { t2 = num2.toString().split(".")[1].length; } catch (e) { t2 = 0; }
        r1 = Number(num1.toString().replace(".", ""));
        r2 = Number(num2.toString().replace(".", ""));
        return (r1 / r2) * Math.pow(10, t2 - t1);
    },


}


//////////////////
// WEBPACK FOOTER
// ./common/setNumber.js
// module id = null
// module chunks = 